import React, { useEffect, useState } from 'react';
import axios from 'axios';

const emptyForm = {
  username: '',
  password: '',
  full_name: '',
  role: 'staff',
  is_active: 1
};

function Users({ currentUser }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
      alert(error.response?.data?.error || 'Lỗi khi tải người dùng');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setFormData(emptyForm);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    }));
  };

  const handleEdit = (user) => {
    setEditingId(user.id);
    setFormData({
      username: user.username,
      password: '',
      full_name: user.full_name,
      role: user.role,
      is_active: user.is_active
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,
        is_active: Number(formData.is_active)
      };

      if (editingId && !payload.password) {
        delete payload.password;
      }

      if (editingId) {
        await axios.put(`/api/users/${editingId}`, payload);
      } else {
        await axios.post('/api/users', payload);
      }

      resetForm();
      fetchUsers();
    } catch (error) {
      console.error('Error saving user:', error);
      alert(error.response?.data?.error || 'Lỗi khi lưu người dùng');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bạn có chắc chắn muốn xóa người dùng này?')) {
      return;
    }

    try {
      await axios.delete(`/api/users/${id}`);
      fetchUsers();
    } catch (error) {
      console.error('Error deleting user:', error);
      alert(error.response?.data?.error || 'Lỗi khi xóa người dùng');
    }
  };

  if (currentUser?.role !== 'admin') {
    return <div className="alert alert-error">Bạn không có quyền quản lý người dùng.</div>;
  }

  if (loading) {
    return <div className="loading">Đang tải người dùng...</div>;
  }

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <h2>Quản Lý Người Dùng</h2>
        <p>Thêm, sửa, khóa hoặc xóa tài khoản đăng nhập hệ thống.</p>
      </div>

      <div className="card">
        <h3 className="card-title">{editingId ? 'Sửa người dùng' : 'Thêm người dùng'}</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr auto', gap: '10px', alignItems: 'end' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Tên đăng nhập</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                disabled={Boolean(editingId)}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{editingId ? 'Mật khẩu mới' : 'Mật khẩu'}</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={editingId ? 'Để trống nếu không đổi' : ''}
                required={!editingId}
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Họ tên</label>
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Vai trò</label>
              <select name="role" value={formData.role} onChange={handleChange}>
                <option value="staff">Nhân viên</option>
                <option value="admin">Quản trị</option>
              </select>
            </div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <label style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  name="is_active"
                  checked={Number(formData.is_active) === 1}
                  onChange={handleChange}
                />
                Hoạt động
              </label>
              <button type="submit">Lưu</button>
              {editingId && <button type="button" onClick={resetForm} style={{ background: '#999' }}>Hủy</button>}
            </div>
          </div>
        </form>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Tên đăng nhập</th>
              <th>Họ tên</th>
              <th>Vai trò</th>
              <th>Trạng thái</th>
              <th>Hành động</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td>{user.username}</td>
                <td>{user.full_name}</td>
                <td>{user.role === 'admin' ? 'Quản trị' : 'Nhân viên'}</td>
                <td>{Number(user.is_active) === 1 ? 'Hoạt động' : 'Khóa'}</td>
                <td>
                  <button onClick={() => handleEdit(user)}>Sửa</button>
                  <button
                    className="danger"
                    onClick={() => handleDelete(user.id)}
                    style={{ marginLeft: '5px' }}
                    disabled={currentUser?.id === user.id}
                  >
                    Xóa
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Users;
